import { render, staticRenderFns } from "./BitacoraDetailsPlanner.vue?vue&type=template&id=4a03ff96&"
import script from "./BitacoraDetailsPlanner.vue?vue&type=script&lang=js&"
export * from "./BitacoraDetailsPlanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports